import { Apis } from '../models/apis';
import { ErrorResponseObject } from '../models/error-response-object';
import { getStandardErrorMessageKey } from './get-standard-error-message-key';

export function extractAndHandleError(
  error: unknown,
  api: Apis,
  handleError: (errorText: string) => void
) {
  if (error !== null && typeof error === 'object') {
    const errorObject = error as Record<string, unknown>;
    if (typeof errorObject['errorCode'] === 'number') {
      handleError(getStandardErrorMessageKey(api, errorObject['errorCode']));
    } else {
      const errorResponse = error as ErrorResponseObject;
      if (typeof errorResponse.error?.errorCode !== 'undefined') {
        handleError(
          getStandardErrorMessageKey(api, errorResponse.error.errorCode)
        );
      } else if (typeof errorResponse.errorCode === 'undefined') {
        handleError(getStandardErrorMessageKey(api, -1));
      } else {
        handleError(getStandardErrorMessageKey(api, errorResponse.errorCode));
      }
    }
  } else if (typeof error === 'number') {
    handleError(getStandardErrorMessageKey(api, error));
  } else {
    handleError(getStandardErrorMessageKey(api, -1));
  }
}
